import { NgModule } from '@angular/core';
import { LibBankIconComponent } from './lib-bank-icon.component';

@NgModule({
  declarations: [LibBankIconComponent],
  imports: [],
  exports: [LibBankIconComponent],
})
export class LibBankIconModule {}
